import ChevronIcon from "assets/icons/ChevronIcon";
import PersonIcon from "assets/icons/PersonIcon";

export interface PersonProps {
  name: string;
  onClick?: () => void;
}
export default function Person({ name, onClick }: PersonProps) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 24,
        cursor: "pointer",
      }}
      onClick={() => onClick && onClick()}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <PersonIcon />
        <span>{name}</span>
      </div>
      <div>
        <ChevronIcon rotate="left" />
      </div>
    </div>
  );
}
